import {
  dangerPrimary,
  infoPrimary,
  successPrimary,
  warningPrimary,
} from "constants/colorTokens";
import { getLocaleString } from "utils/localization/locale";

// Locale string constants for Lockbox module
export const LOCALE_STRINGS = {
  // Common
  FILTER: ["common.filter", "Filter"],
  STATUS: ["common.status", "Status"],
  ALL: ["common.all", "All"],
  RESET: ["common.reset", "Reset"],
  SUBMIT: ["common.submit", "Submit"],
  SR_NO: ["common.sr_no", "Sr. No."],
  NAME: ["common.name", "Name"],
  LOCKBOX_ACCOUNT_NUMBER: ["common.lockbox_account_number", "Account Number"],
  DECLARED_TOTAL_AMOUNT: [
    "common.declared_total_amount",
    "Declared Total Amount",
  ],
  BATCH_NUMBER: ["common.batch_number", "Batch Number"],
  UPLOADED_DATE: ["common.uploaded_date", "Uploaded Date"],
  ENTER_BATCH_NUMBER: ["common.enter_batch_number", "Enter Batch Number"],

  // Cash Remittance
  FILE_NAME: ["cash_remittance.file_name", "File Name"],
  LOCKBOX_ACCOUNT_NUMBER_CASH: [
    "cash_remittance.lockbox_Account_number",
    "Lockbox Account Number",
  ],
  PROCESSED: ["cash_remittance.processed", "Processed"],
  PROCESSING: ["cash_remittance.processing", "Processing"],
  ERROR: ["cash_remittance.error", "Error"],

  // Purchase Order
  PENDING: ["purchase_order.pending", "Pending"],

  // Data Import
  LOCKBOX: ["cash_remittance.lockbox_files", "Lockbox Files"],
  LOCKBOX_BATCH_DETAILS: ["cash_remittance.lockbox", "Lockbox Batch Details"],
  PAYMENT_DATE: ["cash_remittance.payment_date", "Payment Date"],
  ERROR_LOG: ["cash_remittance.error_log", "Error Log"],
  DECLARED_ITEM_COUNT: [
    "cash_remittance.declared_item_count",
    "Declared Item Count",
  ],
  LOCKBOX_ITEMS: ["cash_remittance.lockbox_items", "Lockbox Items"],
  // lockbox items
  CHECK_IMAGE_FILE_NAME: [
    "cash_remittance.check_image_file_name",
    "Check Image File Name",
  ],
  REMITTANCE_FILES: ["cash_remittance.remittance_files", "Remittance Files"],
  CHECK_NUMBER: ["cash_remittance.check_number", "Check Number"],
  DECLARED_AMOUNT: ["cash_remittance.declared_amount", "Declared Amount"],
  CUSTOMERS: ["cash_remittance.customers", "Customers"],
  FILE: ["common.file", "File"],
  MATCHING_INFO: ["cash_remittance.matching_info", "Matching Info"],
  LINKED_ROWS: ["cash_remittance.linked_rows", "Linked Rows"],
  UNLINKED_ROWS: ["cash_remittance.unlinked_rows", "Unlinked Rows"],
  BATCH_STATUS: ["cash_remittance.batch_status", "Batch Status"],
};

export const LOCKBOX_ITEMS_LABEL = getLocaleString(
  ...LOCALE_STRINGS.LOCKBOX_ITEMS
);

// Column labels for Lockbox Batches table
export const COLUMN_LABELS = {
  SR_NO: getLocaleString(...LOCALE_STRINGS.SR_NO),
  NAME: getLocaleString(...LOCALE_STRINGS.NAME),
  LOCKBOX_ACCOUNT_NUMBER: getLocaleString(
    ...LOCALE_STRINGS.LOCKBOX_ACCOUNT_NUMBER
  ),
  STATUS: getLocaleString(...LOCALE_STRINGS.STATUS),
  DECLARED_TOTAL_AMOUNT: getLocaleString(
    ...LOCALE_STRINGS.DECLARED_TOTAL_AMOUNT
  ),
  BATCH_NUMBER: getLocaleString(...LOCALE_STRINGS.BATCH_NUMBER),
  UPLOADED_DATE: getLocaleString(...LOCALE_STRINGS.UPLOADED_DATE),
  PAYMENT_DATE: getLocaleString(...LOCALE_STRINGS.PAYMENT_DATE),
  BATCH_STATUS: getLocaleString(...LOCALE_STRINGS.BATCH_STATUS),

  //LOCKBOX_ITEMS
  CHECK_IMAGE_FILE_NAME: getLocaleString(
    ...LOCALE_STRINGS.CHECK_IMAGE_FILE_NAME
  ),
  REMITTANCE_FILES: getLocaleString(...LOCALE_STRINGS.REMITTANCE_FILES),
  CHECK_NUMBER: getLocaleString(...LOCALE_STRINGS.CHECK_NUMBER),
  DECLARED_AMOUNT: getLocaleString(...LOCALE_STRINGS.DECLARED_AMOUNT),
  CUSTOMERS: getLocaleString(...LOCALE_STRINGS.CUSTOMERS),
  FILE: getLocaleString(...LOCALE_STRINGS.FILE),
  MATCHING_INFO: getLocaleString(...LOCALE_STRINGS.MATCHING_INFO),
  LINKED_ROWS: getLocaleString(...LOCALE_STRINGS.LINKED_ROWS),
  UNLINKED_ROWS: getLocaleString(...LOCALE_STRINGS.UNLINKED_ROWS),
};

// Status badge configuration
export const STATUS_MAP = {
  PROCESSING: {
    label: "Processing",
    color: "#4a3700",
    borderColor: "#ffc107",
    backgroundColor: "rgba(255, 193, 7, 0.14)",
  },
  COMPLETED: {
    label: "Completed",
    color: "#0a3622",
    borderColor: "#198754",
    backgroundColor: "rgba(25, 135, 84, 0.14)",
  },
  PROCESSED: {
    label: "Processed",
    color: "#0a3622",
    borderColor: "#198754",
    backgroundColor: "rgba(25, 135, 84, 0.14)",
  },
  FAILED: {
    label: "Failed",
    color: "#58151c",
    borderColor: "#dc3545",
    backgroundColor: "rgba(220, 53, 69, 0.12)",
  },
  ERROR: {
    label: "Error",
    color: "#58151c",
    borderColor: "#dc3545",
    backgroundColor: "rgba(220, 53, 69, 0.12)",
  },
  PARTIALLY_PROCESSED: {
    label: "Partially Processed",
    color: "#04414d",
    borderColor: "#0dcaf0",
    backgroundColor: "rgba(13, 202, 240, 0.12)",
  },
  PENDING: {
    label: "Pending",
    color: "#343a40",
    borderColor: "#6c757d",
    backgroundColor: "rgba(108, 117, 125, 0.14)",
  },
};

// Filter options for status dropdown
export const STATUS_OPTIONS = [
  { value: "PROCESSED", labelLocale: LOCALE_STRINGS.PROCESSED },
  { value: "PROCESSING", labelLocale: LOCALE_STRINGS.PROCESSING },
  { value: "PENDING", labelLocale: LOCALE_STRINGS.PENDING },
  { value: "ERROR", labelLocale: LOCALE_STRINGS.ERROR },
];

export const lockboxBatchDetailsSummaryConfig = [
  {
    key: "lockbox_account_number",
    label: getLocaleString(...LOCALE_STRINGS.LOCKBOX_ACCOUNT_NUMBER),
    type: "TEXT",
    editable: false,
    show: true,
  },
  {
    key: "payment_date",
    label: getLocaleString(...LOCALE_STRINGS.PAYMENT_DATE),
    type: "DATE",
    editable: false,
    show: true,
  },
  {
    key: "declared_total_amount",
    label: getLocaleString(...LOCALE_STRINGS.DECLARED_TOTAL_AMOUNT),
    type: "AMOUNT",
    editable: false,
    show: true,
  },
  {
    key: "uploaded_at",
    label: getLocaleString(...LOCALE_STRINGS.UPLOADED_DATE),
    type: "DATE",
    editable: false,
    show: true,
  },
  {
    key: "declared_item_count",
    label: getLocaleString(...LOCALE_STRINGS.DECLARED_ITEM_COUNT),
    type: "TEXT",
    editable: false,
    show: true,
  },
  {
    key: "error_log",
    label: getLocaleString(...LOCALE_STRINGS.ERROR_LOG),
    type: "TEXT",
    editable: false,
    show: true,
  },
];

export const tagTypeMaps = {
  ERROR: dangerPrimary,
  WARNING: warningPrimary,
  INFO: infoPrimary,
  SUCCESS: successPrimary,
};
